// extracted by mini-css-extract-plugin
export default {"input":"src-modules-form-Input-style__input_s6CHN","globalError":"src-modules-form-Input-style__globalError_9sUWH"};